// src/features/onboarding/onboardingScopes.js

// The onboarding checklist counts the department's roles, rooms, equipment and tasks
export const ONBOARDING_SCOPES = ['role:read', 'room:read', 'equipment:read', 'task:read'];
